/* eslint-disable import/prefer-default-export */
export const objCompanyDefine = {
  CISCO: 9,
  ARUBA: 14823,
  SAMSUNG: 236,
  XIRRUS: 21013,
};



// WEBPACK FOOTER //
// ./src/constants/company.js